import Vue from 'vue'
import axios from "axios"
import moment from 'moment'
import {Cookies} from 'quasar-framework'

Vue.use({
    install() {
        Vue.prototype.$watchUser = function (info, item) {

            if (info === 'item') {
                const date_arrival = localStorage.getItem(document.location.pathname)
                item['date_arrival'] = date_arrival

                let parsed = JSON.stringify(item)
                localStorage.setItem('item', parsed)
            } else  {
                const data = {
                    initial_date: localStorage.getItem(this.$route.path),
                    finish_date: info === 'click' ? null : moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss'),
                    finish_method: info === 'click' ? '' : info,
                    url: document.location.href,
                    click: localStorage.getItem('click'),
                    item: localStorage.getItem('item'),
                    portal_id: Cookies.get('portal')
                }
                info === 'redirect' || info === 'closed' ? localStorage.removeItem(this.$route.path) : ''
                axios.post(`${config.SkySMSUrl}/watch-user`, data).then(() => {
                    localStorage.removeItem('item')
                })
            }
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/watchUser.js